import { ReactElement, useRef } from "react";
import classNames from "classnames";
import { UiaButton, UiaIcon } from "@rotorstudios/fe-ui";

import UimAROverlay, {
  iAROverlay,
} from "../../uiComponents/molecules/uimAROverlay/UimAROverlay";
import UiaIconAR from "../../uiComponents/atoms/uiaIconAR/UiaIconAR";
import TrackedButton from "../../modules/toyota-kit/TrackedButton";
import useUiMButtonAR from "./useUiMButtonAR";
import "./_UiMButtonAR.scss";

export type iARButton = {
  tLabel: string;
  overlay: iAROverlay;
  ready: iAROverlay;
  unavailable: iAROverlay;
};

type UiMButtonARProps = {
  className?: string;
  iconButton?: boolean;
  secondary?: boolean;
  inverse?: boolean;
  gaProps?: {
    eventId?: string;
    buttonName?: string;
    viewName: string;
    viewSection: string;
  };
  gaDataButtonName?: string;
  ar: iARButton;
  qaId?: string;
  onMouseEnter?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

const UiMButtonAR = ({
  className = "",
  iconButton = false,
  secondary = false,
  inverse = false,
  gaProps,
  gaDataButtonName,
  ar,
  qaId,
  onMouseEnter,
  onMouseLeave,
}: UiMButtonARProps): ReactElement => {
  const {
    projectClass,
    arUrlLink,
    isOpenQRCodeOverlay,
    isOpenQRCodeLinkOverlay,
    isOpenARUnavailableOverlay,
    onClickARHandler,
    setIsOpenQRCodeOverlay,
    setIsOpenQRCodeLinkOverlay,
    setIsOpenARUnavailableOverlay,
  } = useUiMButtonAR({ gaProps });

  const labelTextRef = useRef<any>(null);

  const getClassName = () => classNames(`${projectClass}_UiMButtonAR`, className);

  return (
    <>
      <>
        {iconButton ? (
          <TrackedButton
            customClassName="ARButton"
            variant="secondary"
            isAlwaysLargeTypography
            onClick={onClickARHandler}
            gaDataButtonName={gaDataButtonName}
            qaId={qaId}
          >
            {ar?.tLabel}
          </TrackedButton>
        ) : (
          <UiaButton
            className={getClassName()}
            onClick={onClickARHandler}
            pill
            secondary={secondary}
            inverse={inverse}
            primary={!secondary}
            qaId={qaId}
          >
            <div className={`${projectClass}_UiMButtonAR_Label`}>
              <span
                ref={labelTextRef}
                className={`${projectClass}_UiMButtonAR_Label_Text`}
              >
                {ar?.tLabel}
              </span>
              <UiaIcon inverse={inverse} icon={<UiaIconAR />} />
            </div>
          </UiaButton>
        )}
      </>
      <UimAROverlay
        urlLink={arUrlLink}
        arOverlay={ar?.overlay}
        arReady={ar?.ready}
        arUnavailable={ar?.unavailable}
        openQRCodeOverlay={isOpenQRCodeOverlay}
        openQRCodeLinkOverlay={isOpenQRCodeLinkOverlay}
        openARUnavailableOverlay={isOpenARUnavailableOverlay}
        setOpenQRCodeLinkOverlay={setIsOpenQRCodeLinkOverlay}
        setOpenQRCodeOverlay={setIsOpenQRCodeOverlay}
        setOpenARUnavailableOverlay={setIsOpenARUnavailableOverlay}
      />
    </>
  );
};

export default UiMButtonAR;
